const LANGUAGE_STORAGE_KEY = "wifiads-language";
const TIME_ZONE_STORAGE_KEY = "wifiads-time-zone";

export const SUPPORTED_LANGUAGES = ["es", "en"];
export const DEFAULT_LANGUAGE = "es";
export const DEFAULT_TIME_ZONE = "America/Santo_Domingo";

export function normalizeLanguage(language) {
  return SUPPORTED_LANGUAGES.includes(String(language || "").split("-")[0])
    ? String(language).split("-")[0]
    : DEFAULT_LANGUAGE;
}

export function getPreferredLanguage() {
  try {
    const value = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return value ? normalizeLanguage(value) : null;
  } catch (error) {
    return null;
  }
}

export function persistPreferredLanguage(language) {
  const normalized = normalizeLanguage(language);
  localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  return normalized;
}

export function getPreferredTimeZone() {
  try {
    return localStorage.getItem(TIME_ZONE_STORAGE_KEY) || DEFAULT_TIME_ZONE;
  } catch (error) {
    return DEFAULT_TIME_ZONE;
  }
}

export function persistPreferredTimeZone(timeZone) {
  const normalized = timeZone || DEFAULT_TIME_ZONE;
  localStorage.setItem(TIME_ZONE_STORAGE_KEY, normalized);
  return normalized;
}
